var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0105 2.35352H8.23966C4.98924 2.35352 2.35425 4.98851 2.35425 8.23893V20.0098C2.35425 23.2602 4.98924 25.8952 8.23966 25.8952H20.0105C23.2609 25.8952 25.8959 23.2602 25.8959 20.0098V8.23893C25.8959 4.98851 23.2609 2.35352 20.0105 2.35352Z",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.833 13.381C18.9783 14.3606 18.811 15.3611 18.3548 16.2401C17.8987 17.1192 17.177 17.832 16.2924 18.2773C15.4078 18.7225 14.4054 18.8775 13.4276 18.7202C12.4499 18.5628 11.5466 18.1012 10.8463 17.4009C10.1461 16.7006 9.68442 15.7974 9.52709 14.8196C9.36975 13.8419 9.52473 12.8394 9.96998 11.9548C10.4152 11.0702 11.1281 10.3485 12.0071 9.89239C12.8861 9.43628 13.8866 9.26895 14.8663 9.41421C15.8655 9.56239 16.7906 10.028 17.5049 10.7423C18.2192 11.4566 18.6848 12.3817 18.833 13.381Z",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5986 7.65234H20.6114",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.f4b36cbf07e5f69a9cc8747888ecd85e.svg";
export { ForwardRef as ReactComponent };